import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { v4 as uuidv4 } from 'uuid'
// Modules
import ActivityZones from './modules/activityZones'
import Billing from './modules/billing'
import Events from './modules/events'
import Notifications from './modules/notifications'
import Organizations from './modules/organizations'
import Permissions from './modules/permissions'
import Properties from './modules/properties'
import PropertyZones from './modules/propertyZones'
import Reservations from './modules/reservations'
import Users from './modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ActivityZones,
    Billing,
    Events,
    Notifications,
    Organizations,
    Permissions,
    Properties,
    PropertyZones,
    Reservations,
    Users,
  },
  state: {
    baseURL: process.env.VUE_APP_PORTAL,
    validatorURL: process.env.VUE_APP_VALIDATOR_URL,
    drawer: null,
    accountDrawer: false,
    userToken: '',
    panels: null,
    error: {},
    isError: false,
    loading: true,
    fromDashboard: false,
    messages: [],
  },
  getters: {
    baseURL (state) {
      return state.baseURL
    },
    validatorURL (state) {
      return state.validatorURL
    },
    token (state) {
      return state.userToken
    },
    panels (state) {
      return state.panels
    },
    isError (state) {
      return state.isError
    },
    error (state) {
      return state.error
    },
    isLoading (state) {
      return state.loading
    },
    fromDashboard (state) {
      return state.fromDashboard
    },
    messages (state) {
      return state.messages
    },
    getNameForDetailPage (state, getters) {
      return (type) => {
        switch (type) {
          case 'organizations': return getters['Organizations/orgData'].name
          case 'properties': return getters['Properties/propertyDetails'].name
          case 'users': return getters['Users/userDataName']
        }
      }
    },
    search (state) {
      return state.search
    },
  },
  mutations: {
    setDrawer (state, payload) {
      state.drawer = payload
    },
    setAccountDrawer (state, payload) {
      state.accountDrawer = payload
    },
    updateUserToken (state, payload) {
      state.userToken = payload
    },
    resetPanels (state) {
      state.panels = null
    },
    setMessages (state, payload) {
      state.messages = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    toggleError (state, payload) {
      state.isError = payload
    },
    setLoadingState (state, payload) {
      state.loading = payload
    },
    setFromDashboard (state) {
      state.fromDashboard = true
    },
  },
  actions: {
    setToken ({ state, commit, dispatch }) {
      return new Promise((resolve) => {
        const refreshToken = Cookies.get('refreshToken')
        if (!refreshToken) {
          dispatch('logout')
        }
        const expireTime = new Date(jwtDecode(refreshToken).exp * 1000)
        if (expireTime <= Date.now()) {
          dispatch('logout')
        }
        axios.post(`${state.baseURL}/refresh`, { refreshToken })
          .then((response) => {
            const { userToken, refreshToken, expiresAt } = response.data.data
            commit('updateUserToken', userToken)
            localStorage.refreshToken = refreshToken
            localStorage.expiresAt = expiresAt
            const decodedUserToken = jwtDecode(userToken)
            if (decodedUserToken && decodedUserToken.sub && window.gtag) {
              window.gtag('config', 'UA-77912240-10', { user_id: decodedUserToken.sub })
            }
            resolve()
          })
          .catch(() => {
            dispatch('logout')
          })
      })
    },
    logout () {
      window.location = `${process.env.VUE_APP_LOGIN}/logout?redirect=${window.location.href}`
    },
    getCSV ({ state, dispatch }, { APIPath, payload, fileName }) {
      return axios.post(APIPath, payload)
        .then((response) => {
          const messagePayload = { type: 'success', text: 'Download Started...' }
          dispatch('updateMessages', messagePayload, { root: true })
          const blob = new Blob([response.data], { type: 'text/csv' })
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName || 'download'
          a.click()
          a.remove()
        })
    },
    async fetchPanels ({ state, commit, dispatch }, payload) {
      commit('resetPanels')
      await axios.get(`${state.baseURL}/${payload.type}/${payload.id}/panels`, {
      }).then((res) => {
        if (res) {
          state.panels = res.data.data.panels
        }
      })
    },
    updateMessages ({ state, commit }, payload) {
      payload.id = uuidv4()
      const currentMessages = state.messages
      currentMessages.push(payload)
      commit('setMessages', currentMessages)
    },
    removeReadMessages ({ state, commit }, messages) {
      const currentMsgs = state.messages
      for (const message of messages) {
        const messageIndex = currentMsgs.findIndex(msg => msg.id === message)
        currentMsgs.splice(messageIndex, 1)
      }
      commit('setMessages', currentMsgs)
    },
  },
})
